import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { history, useIntl, useSelector } from 'umi';
import moment from 'moment';
// import { Icon, Bubble, Button, Modal } from 'tea-component';
import { Button, Modal } from 'tea-component';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import NoEntityCard from '@/pages/intelligence/pages/Compare/components/NoEntityCard';
import { TOP_CHARTS_TYPES } from '@/pages/intelligence/components/ChartBubble';
import { ComposedDateMode } from '@/pages/intelligence/components/ComposedDatePicker/enums';
import Filter from '../components/ActiveRevDownFilter';
// import GameHeader from '@/pages/intelligence/pages/Compare/MobileGames/components/GameHeader';
import GameList from '@/pages/intelligence/pages/Compare/MobileGames/components/GameList';
import AddEntities from '../../components/AddEntities';
import Actionbar from '../../components/Actionbar';
import MetricTable from '../components/MetricTable/ActiveRevDownMetricTable';
import CumulativeTable from '../components/CumulativeTable';
import Visualis from '../components/Visualis';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import EntityRenderer from '../EntityRenderer';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import {
  getCompareMetric,
  fetchCompareGameTrends,
} from '@/pages/intelligence/services/mobileCompare';
import {
  fetchKeywords,
  fetchGamesByKeyword,
  fetchSimilarGames,
  addComparingGames,
  deleteComparingGames,
} from '@/pages/intelligence/pages/Compare/MobileGames/services';
import {
  getDateTypeOfBackend,
  feachTimeTypeToFilterTimeType,
} from '@/pages/intelligence/utils/common';
import { isEmpty } from '@/pages/intelligence/utils/commonUtils';
import { formatDateStrPlus } from '@intelligence/v3/utils/date';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import {
  transIsCountryToApi,
  calMax,
  getGameTime,
  getDownloadDates,
  getIsRangeDayMonth,
  getOtherDateFormat,
} from '../utils';
import {
  getInitialFilterParams,
  getLaunchTimeUrlValues,
  getCompareisCustomVaildUrlParams,
} from './utils';
import {
  DEFAULT_FILTER_PARAMS,
  GAME_DETAILS_TABS,
  GAME_DETAILS_SUB_TABS,
  Key_Metrics_Map,
} from './config';
import { MAXGAMENUM } from '../../constants';
import { DateTypeFrontend } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useUrlGamesParam from '../../hooks/useUrlGamesParam';

import type {
  IBaseProps,
  IGameType,
  IDateType,
  IDateValue,
} from '@/pages/intelligence/types/common';
import type { IMobileComparePageId } from '@/pages/intelligence/types/mobileCompare';
import type { IComposedDateData } from '@/pages/intelligence/components/ComposedDatePicker/types';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import TipContext from '@/pages/home/components/TipContext';
import { DEFAULT_FORM_VALUE } from '../components/ActiveRevDownFilter/config';
import { getDbiUrlParams } from '@intelligence/components/Filter/util';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { getCountriesExtendParams } from '@intelligence/utils/filterUtils';
import useEarliesTimeHasData from '@/pages/intelligence/hooks/useEarliesTimeHasData';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
import { compareMobileGames } from '@intelligence/v3/constants/downloadLogPoint';

const getEarliesTimeType = (mainSegment: string) => {
  if (mainSegment === 'revenue') {
    return hasDataTimerParams?.compareMobileRevenue?.type;
  }
  if (mainSegment === 'download') {
    return hasDataTimerParams?.compareMobileDownlaods?.type;
  }
  return hasDataTimerParams?.compareMobileActiveuser?.type;
};
interface IActiveRevDownProps extends IBaseProps {
  entityType: IGameType;
  topChartsType?: string;
  mainSegment: IMobileComparePageId;
  mainSegmentText: any;
}

const ActiveRevDown: React.FC<IActiveRevDownProps> = (props) => {
  const {
    entityType,
    topChartsType = TOP_CHARTS_TYPES.COMPARE_MOBILE_ACTIVEREVDOWN,
    mainSegment,
    mainSegmentText,
  } = props;

  const { formatMessage } = useIntl();

  const { filterExtend } = useFilterExtend({});

  const { latestTimeTypeHasData } = useEarliesTimeHasData({
    filterType: getEarliesTimeType(mainSegment),
  });

  const filterState = useSelector((state: any) => state?.[FILTER_EXTEND_NAMESPACE] || {});
  const isOperate = filterState?.isOperate;

  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [noData, setNoData] = useState(false);
  const [gameList, setGameList] = useState<any[]>([]);
  const [ClearVisible, setClearVisible] = useState(false);
  const [filterValue, setFilterVale] = useState(isOperate ? filterExtend : DEFAULT_FORM_VALUE);
  const [filterLoading, setFilterLoading] = useState(true);
  const [regionOptions, setRegionOptions] = useState([]);
  // 绝对时间 YYYY-MM-DD 这种格式 参数最外层的start_date、end_date
  const [absoluteDateValue, setAbsoluteDateValue] = useState<IDateValue>(['', '']);
  // 相对时间
  const [relativeDateValue, setRelativeDateValue] = useState<IDateValue>(['1', '30']);

  /** 组合时间筛选器部分 **/
  const [composedDateData, setComposedDateData] = useState<IComposedDateData>({
    mode: ComposedDateMode.Absolute,
    dateType: 'date',
    dateValue: [],
  });
  const handleComposeDateChange = (
    mode: ComposedDateMode,
    dateType: IDateType,
    dateValue: IDateValue,
  ) => {
    const composedDateDataTemp = {
      ...composedDateData,
      mode,
      dateType,
      dateValue,
    };
    setComposedDateData(composedDateDataTemp);
    if (mode === ComposedDateMode.Absolute) {
      setAbsoluteDateValue(dateValue);
      fetchCompareGameTrendsData(
        getChartApiData({
          apiData,
          isRangeDayMonth: false,
          dateType,
          dateValue,
        }),
        false,
      );
      return;
    }
    setRelativeDateValue(dateValue);
    fetchCompareGameTrendsData(
      getChartApiData({
        apiData,
        isRangeDayMonth: true,
        dateType,
        dateValue: absoluteDateValue,
        rangeValue: dateValue,
      }),
      true,
    );
  };
  /** 组合时间筛选器部分 **/

  const echartDateType = useMemo(
    () => getOtherDateFormat(composedDateData?.dateType),
    [composedDateData?.dateType],
  );
  const [echartLoading, setEchartLoading] = useState(false);
  const [echartNoData, setEchartNoData] = useState(false);
  const [lineData, setLineData] = useState<any[]>([]);
  // 累计值展示表格用到的
  const [trends, setTrends] = useState<any[]>([]);
  const initialFilterParams = getInitialFilterParams(
    isOperate,
    filterExtend,
    DEFAULT_FILTER_PARAMS,
  );
  const [heatMap, setHeatMap] = useState(initialFilterParams?.showHeatMap);
  const [showCountries, setShowCountries] = useState(initialFilterParams?.showCountries);
  const [apiData, setApiData] = useState({
    entity_type: entityType,
    metric: mainSegment,
    region_type: initialFilterParams.regionType,
    regions: initialFilterParams.regionValue,
    data_sources: initialFilterParams.dataSource,
    game_ids: [], // game_id为游戏id,查询用，
    is_country: transIsCountryToApi(showCountries), // 0:不要country的数据 1:只要country数据 2:数据全返回
  });

  const gamesEntities = useMemo(() => {
    if (!Array.isArray(gameList)) return [];
    return gameList.map((item, index) => ({
      ...item,
      gameId: item?.game_id || '',
      gameName: item?.name || '',
      entityType: item?.entity_type || entityType,
      cover: item?.cover || '',
      publisher: item?.publisher || '',
      releaseTime: item?.release_time || '',
      sequence: item?.sequence || index + 1,
    }));
  }, [gameList]);

  // Get existing game IDs for URL games param deduplication
  const existingGameIds = useMemo(() => {
    return gameList.map((item) => item?.game_id).filter(Boolean);
  }, [gameList]);

  // Callback to refresh data after games are added from URL
  const handleUrlGamesAdded = useCallback((_games: any[]) => {
    // Refresh the page data to include newly added games
    // Mobile Games Compare page fetches game list from backend, so we just refresh
    if (!filterLoading) {
      getPageData();
    }
  }, [filterLoading]);

  // Handle URL games parameter (?games=id1,id2,...)
  useUrlGamesParam({
    entityType,
    existingGameIds,
    addComparingGames,
    onGamesAdded: handleUrlGamesAdded,
  });

  const geUrlParamsData = (history: any) => {
    let newFetchParams = {};
    const urlParams: any = getDbiUrlParams(history); // todo query ts报错
    if (typeof urlParams === 'object' && Object.keys(urlParams)?.length) {
      // 优先使用url的值
      const params = handleFilterParams(urlParams);
      // 自定参数
      const isCustomParams = getCompareisCustomVaildUrlParams(history);
      newFetchParams = { ...newFetchParams, ...params, ...isCustomParams };
    }
    return newFetchParams;
  };
  const formatRegionParams = (markets: string[]) => {
    // 不同国家国家取交集,并且把交集的结果重新赋值到继承值中
    const { regionValues, filterExtendValue } = getCountriesExtendParams({
      regionOptions, // 国家筛选器options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: false,
      markets,
      filterExtend,
    });
    // setFilterExtend(filterExtendValue);
    return regionValues;
  };

  const handleFilterParams = (params: any) => {
    const newFetchParams: any = {};
    const marketExtend = params?.[filterKeyMap.REGION];
    const dataSourcesExtend = params?.[filterKeyMap.ICONABLE_CHECKBOX_SELECT];
    const heatMapExtend = params?.[filterKeyMap.HEAT_MAP];
    const showTopCountriesExtend = params?.[filterKeyMap.SHOW_TOP_COUNTRIES];
    const extendValue = { ...(filterValue || {}) };
    if (marketExtend) {
      // 不同国家国家取交集,并且把交集的结果重新赋值到继承值中
      const regionValues = formatRegionParams(marketExtend?.markets);
      newFetchParams.region_type = regionValues?.regionType || 'market';
      newFetchParams.regions = regionValues?.regions;
      // newFetchParams.region_type = 'market';
      // newFetchParams.regions = marketExtend?.markets;
      extendValue[filterKeyMap.REGION] = marketExtend;
    }

    if (dataSourcesExtend) {
      /** 数据源参数取交集 */
      const dataSourcesVal = dataSourcesExtend?.value?.filter((val: string) =>
        ['appannie', 'sensortower']?.includes(val),
      );
      newFetchParams.data_sources =
        dataSourcesVal?.length > 0 ? dataSourcesVal : ['appannie', 'sensortower'];
      extendValue[filterKeyMap.ICONABLE_CHECKBOX_SELECT] = dataSourcesExtend;
    }
    if (heatMapExtend) {
      setHeatMap(heatMapExtend.value);
      extendValue[filterKeyMap.HEAT_MAP] = heatMapExtend;
    }
    if (showTopCountriesExtend) {
      setShowCountries(showTopCountriesExtend?.value);
      newFetchParams.is_country = transIsCountryToApi(showTopCountriesExtend?.value);
      extendValue[filterKeyMap.SHOW_TOP_COUNTRIES] = showTopCountriesExtend;
    }
    setFilterVale(extendValue);
    return newFetchParams;
  };

  const getPageData = async () => {
    const urlParams = geUrlParamsData(history);
    // setFilterVale
    const _apiData = { ...apiData, metric: mainSegment, ...urlParams };
    // 从url获取launch筛选器值
    const urlComposedDateData = getLaunchTimeUrlValues(history) || composedDateData;
    setComposedDateData(urlComposedDateData);
    // 给筛选器赋值
    if (urlComposedDateData?.mode === ComposedDateMode.Absolute) {
      setAbsoluteDateValue(urlComposedDateData.dateValue);
    }
    if (urlComposedDateData?.mode === ComposedDateMode.Relative) {
      setRelativeDateValue(urlComposedDateData.dateValue);
    }
    let newGameList = gameList;
    const isRangeDayMonth = getIsRangeDayMonth(urlComposedDateData?.mode);
    if (isRangeDayMonth) {
      // 先获取到GameList的数据拿来获取时间线
      newGameList = await getCompareMetricData(_apiData);
    } else {
      getCompareMetricData(_apiData);
    }
    fetchCompareGameTrendsData(
      getChartApiData({
        apiData: _apiData,
        isRangeDayMonth,
        dateType: urlComposedDateData?.dateType,
        dateValue: urlComposedDateData?.dateValue,
        rangeValue: urlComposedDateData?.dateValue,
        newGameList,
      }),
      isRangeDayMonth,
    );
  };

  useEffect(() => {
    if (filterLoading) {
      // 拿缓存值需要拿到用户id
      setLoading(true);
      return;
    }
    getPageData();
  }, [mainSegment, filterLoading]);

  const getCompareMetricData = async (_apiData: any) => {
    setLoading(true);
    setApiData(_apiData);
    try {
      const res = await getCompareMetric({ ..._apiData });
      const _gameList = res?.data?.compare_list;
      if (Array.isArray(_gameList)) {
        const _calList = calMax(_gameList);
        const gameIds: any = [];
        _gameList?.forEach((item) => {
          gameIds.push(item?.game_id);
        });
        setApiData({ ..._apiData, game_ids: gameIds });
        setGameList(_calList);
        setNoData(false);
        setLoading(false);
        return _calList;
      }
      setNoData(true);
      setGameList([]);
      resetHandle();
    } catch (err) {
      console.log(err);
      setNoData(true);
      setGameList([]);
      resetHandle();
    }
    setLoading(false);
    return [];
  };

  const fetchCompareGameTrendsData = async (_apiData: any, isRangeDayMonth: boolean) => {
    // console.log(_apiData, isRangeDayMonth)
    setEchartLoading(true);
    try {
      const res = await fetchCompareGameTrends({ ..._apiData });
      const _gameList = res?.data?.trends || [];
      // 绝对时间，回写时间范围，相对时间，不回写时间范围
      if (!isRangeDayMonth) {
        const req = res?.req;
        const dateType = req?.period || 'day';
        const startDate = formatDateStrPlus(req?.start_date);
        const endDate = formatDateStrPlus(req?.end_date);
        const absoluteDateValueTmp = startDate && endDate ? [startDate, endDate] : [];
        setAbsoluteDateValue(absoluteDateValueTmp);
        setComposedDateData({
          mode: ComposedDateMode.Absolute,
          dateType: feachTimeTypeToFilterTimeType(dateType),
          dateValue: absoluteDateValueTmp,
        });
      }
      setLineData(getEchartsGameData(_gameList, isRangeDayMonth));
      setTrends(_gameList);
      setEchartNoData(getEchartsGameNoData(_gameList, isRangeDayMonth));
    } catch (err) {
      setLineData([]);
      setTrends([]);
      setEchartNoData(true);
    }
    setEchartLoading(false);
  };

  const handleAddGame = () => {
    setVisible(true);
  };

  const handleDelGame = async (gameId: string) => {
    // 调用后端删除接口
    const isok = await delGames([gameId]); // 没有游戏时做兼容
    if (!isok) {
      // maybe 网络出错
      return;
    }
    // 过滤掉删除的游戏
    const _gameIds: any = [];
    const filterList = gameList?.filter((item) => {
      if (item?.game_id !== gameId) {
        _gameIds.push(item.game_id);
      }
      return item?.game_id !== gameId;
    });
    setGameList(calMax(filterList));
    if (filterList?.length === 0) {
      setNoData(true);
      resetHandle();
    } else {
      const _apiData = { ...apiData };
      _apiData.game_ids = _gameIds;
      setApiData(_apiData); // 删除后给apiData的game_ids赋值
      // 处理删除后的拆线图数据
      const filterEchartList = lineData?.filter((item) => item?.id !== gameId);
      const filterTrends = trends?.filter((item) => item?.game_id !== gameId);
      setLineData(filterEchartList);
      setTrends(filterTrends);
    }
  };

  const getEchartsGameData = (gamelist: any, isRangeDayMonth: boolean) => {
    const arrTemp = [];
    for (const n in gamelist) {
      if (isRangeDayMonth) {
        for (const x in gamelist[n].history) {
          gamelist[n].history[x].time = gamelist[n].history[x].launch_date;
        }
      }
      const objTemp = {
        name: gamelist[n].name,
        metric_value_list: gamelist[n].history,
        id: gamelist[n].game_id,
      };
      arrTemp.push(objTemp);
    }
    return arrTemp;
  };

  const getEchartsGameNoData = (gameList: any[], isRangeDayMonth: boolean): boolean => {
    if (!Array.isArray(gameList)) return true;
    const dateKey = isRangeDayMonth ? 'launch_date' : 'time';
    for (const gameItem of gameList) {
      const gameId = gameItem?.game_id;
      const gameHistories = gameItem?.history;
      if (!gameId || !Array.isArray(gameHistories)) continue;
      for (const gameHistory of gameHistories) {
        const gameHistoryDate = gameHistory?.[dateKey];
        const gameHistoryMetrics = gameHistory?.metric_value_list;
        if (!gameHistoryDate || !Array.isArray(gameHistoryMetrics)) continue;
        for (const gameHistoryMetric of gameHistoryMetrics) {
          if (!isEmpty(gameHistoryMetric?.value)) return false;
        }
      }
    }

    return true;
  };

  const delGames = async (ids: string[]) => {
    setLoading(true);
    try {
      await deleteComparingGames(ids);
      setLoading(false);
      return true;
    } catch (err) {
      setLoading(false);
      return false;
    }
  };

  const handleClearGame = async () => {
    const idList = gameList?.map(
      (item) => item?.game_id, // 删除用game_id
    );
    const isok = await delGames(idList);
    if (!isok) {
      // maybe 网络出错
      return;
    }
    // 清空   game_ids
    const _apiData = { ...apiData };
    _apiData.game_ids = [];
    setApiData(_apiData);
    setGameList([]);
    setNoData(true);
    // resetHandle();
  };

  const handleCompareConfirm = async (gamesIds: string[], games: any[]) => {
    setVisible(false);
    if (!gamesIds?.length || !games?.length) return;
    try {
      await addComparingGames(games);
    } catch (e) {
      console.warn(e);
      // 添加数据失败
      setVisible(false);
      return;
    }
    // 添加数据后再重新请求数据接口
    const apiDataTmp: any = { ...apiData };
    const isRangeDayMonth = getIsRangeDayMonth(composedDateData?.mode);
    apiDataTmp.game_ids = gamesIds;
    getCompareMetricData(apiDataTmp);
    fetchCompareGameTrendsData(
      getChartApiData({
        apiData: apiDataTmp,
        isRangeDayMonth,
      }),
      isRangeDayMonth,
    );
  };

  const handleCompareCancel = () => {
    setVisible(false);
  };

  const handleConfirm = (values: any) => {
    const _apiData = {
      ...apiData,
      region_type: values?.regionType,
      regions: values?.regionValue,
      data_sources: values?.dataSource,
      is_country: transIsCountryToApi(values?.showCountries),
    };
    setHeatMap(values.showHeatMap);
    setShowCountries(values.showCountries);
    setApiData(_apiData);
    if (loading || gameList?.length === 0) {
      return;
    }
    // 判断是否要调用接口
    if (
      // 前面2个筛选器不变 &&  (showCountries不变或showCountries === false)
      values.regionType === apiData.region_type &&
      JSON.stringify(values.regionValue) === JSON.stringify(apiData.regions) &&
      JSON.stringify(values.dataSource) === JSON.stringify(apiData.data_sources)
    ) {
      if (values.showCountries && values.showCountries !== showCountries) {
        // 勾选国家的不用请求折线图
        getCompareMetricData(_apiData);
      } else if (
        (values.showCountries === false && values.showCountries !== showCountries) ||
        values.showHeatMap !== heatMap
      ) {
        // 不调接口
      } else {
        // 没有任何改变
        // setLoading(true)
        // setTimeout(() => {
        //   setLoading(false)
        // }, 100)
        const isRangeDayMonth = getIsRangeDayMonth(composedDateData?.mode);
        getCompareMetricData(_apiData);
        fetchCompareGameTrendsData(
          getChartApiData({
            apiData: _apiData,
            isRangeDayMonth,
          }),
          isRangeDayMonth,
        );
      }
    } else {
      const isRangeDayMonth = getIsRangeDayMonth(composedDateData?.mode);
      // 获取接口
      getCompareMetricData(_apiData);
      fetchCompareGameTrendsData(
        getChartApiData({
          apiData: _apiData,
          isRangeDayMonth,
        }),
        isRangeDayMonth,
      );
    }
  };

  const getChartApiData = (params: {
    apiData: any;
    isRangeDayMonth: boolean;
    dateType?: string;
    dateValue?: string[];
    rangeValue?: string[];
    newGameList?: any;
  }) => {
    const {
      apiData,
      isRangeDayMonth,
      dateType = composedDateData?.dateType,
      dateValue = absoluteDateValue,
      rangeValue = relativeDateValue,
      newGameList = gameList,
    } = params;
    let apiDataObj = apiData;
    const otherDateType = getOtherDateFormat(dateType);
    const idList = [];
    for (const n in apiDataObj.game_ids) {
      const obj = {
        game_id: apiDataObj.game_ids[n],
        start_date: isRangeDayMonth
          ? getGameTime(
              newGameList,
              'start_date',
              apiDataObj.game_ids[n],
              otherDateType,
              rangeValue,
            )
          : '',
        end_date: isRangeDayMonth
          ? getGameTime(newGameList, 'end_date', apiDataObj.game_ids[n], otherDateType, rangeValue)
          : '',
      };
      idList.push(obj);
    }
    apiDataObj = { ...apiData, game_ids: idList };

    const _lineApi = {
      ...apiDataObj,
      start_date: !isRangeDayMonth ? formatDateStrPlus(dateValue[0]) : '',
      end_date: !isRangeDayMonth ? formatDateStrPlus(dateValue[1]) : '',
      period: otherDateType?.toLocaleLowerCase(),
      launch_date: !isRangeDayMonth ? 0 : (rangeValue?.[0] as any) * 1,
    };
    return _lineApi;
  };

  const resetHandle = () => {
    const defaultTimeValue = [
      formatDateStrPlus(latestTimeTypeHasData?.date?.[0]),
      formatDateStrPlus(latestTimeTypeHasData?.date?.[1]),
    ];
    setAbsoluteDateValue(defaultTimeValue);
    setRelativeDateValue(['1', '30']);
    setComposedDateData({
      mode: ComposedDateMode.Absolute,
      dateType: 'date',
      dateValue: defaultTimeValue || [],
      // dateValue: [
      //   moment().subtract(30, 'd').format('YYYY-MM-DD'),
      //   moment().format('YYYY-MM-DD'),
      // ],
    });
  };

  const getDetailPath = (gameId: string): string => {
    const tab = GAME_DETAILS_TABS[mainSegment] || 'stats';
    const subTab = GAME_DETAILS_SUB_TABS[mainSegment] || 'activeusers';
    const path = getDetailGamePathCommon({
      entityType,
      gameId,
      tab,
      subTab,
    });
    return path || '';
  };
  const handleGoDetail = (gameId: string) => {
    history.push(getDetailPath(gameId));
  };

  const onFilterInit = (params: any) => {
    const { loading, regionOptions } = params || {};
    setFilterLoading(loading);
    setRegionOptions(regionOptions);
  };

  return (
    <div className="dbi-compare-mobile-active">
      <Filter
        className="dbi-compare-mobile-filter"
        isOperate={true}
        onConfirm={handleConfirm}
        onReset={resetHandle}
        filterValue={filterValue}
        onFilterInit={onFilterInit}
      />

      {/* 加载动画 */}
      {loading && (
        <>
          <Abnormal
            style={{
              // margin: '0 0 64px 0',
              margin: '0 0 20px 0',
              height: 482,
              backgroundColor: '#fff',
              borderRadius: 8,
            }}
            isLoading={true}
          />
          <Abnormal
            style={{ height: 400, backgroundColor: '#fff', borderRadius: 8 }}
            isLoading={true}
          />
        </>
      )}
      {loading || (
        <>
          {/* 无数据 */}
          {noData && <NoEntityCard onAdd={handleAddGame} />}
          {noData || (
            <CardSlotV2
              rightDom={
                <Button
                  type="link"
                  onClick={() => {
                    setClearVisible(true);
                  }}
                >
                  {formatMessage({ id: 'dbi_compare_clear_all' })}
                </Button>
              }
              IconList={false}
              title={formatMessage({ id: 'dbi_games' })}
            >
              <div className="dbi-compare-mobile-content">
                {/* 因为结构不同，所以注释了 加了GameHeader  */}
                {/* <GameHeader
                showSubTitle={gameList?.length >= MAXGAMENUM}
                title={formatMessage({ id: 'dbi_games' })}
                subTitle={formatMessage({ id: 'dbi_compare_select_games_limit_tips' }, { max: MAXGAMENUM })}
                operation={formatMessage({ id: 'dbi_compare_clear_all' })}
                handleOperation={handleClearGame}
              /> */}
                <GameList
                  entityType={entityType}
                  showAddGame={gameList?.length < MAXGAMENUM}
                  list={gameList}
                  handleAdd={handleAddGame}
                  handleDel={handleDelGame}
                  handleGoDetail={handleGoDetail}
                  getDetailPath={getDetailPath}
                />

                <div className="dbi-compare-mobile-bar">
                  <span className="dbi-compare-mobile-header">
                    {formatMessage({ id: Key_Metrics_Map?.[mainSegment] })}
                  </span>
                  {/* <Bubble
                    dark
                    placement="top"
                    content={
                      <div
                        style={{ whiteSpace: 'pre-wrap', maxWidth: '360px' }}
                      >
                        {formatMessage({
                          id: 'dbi_compare_mobile_key_metric_tips',
                        })}
                      </div>
                    }
                  >
                    <Icon
                      type="info"
                      size="s"
                      style={{ marginLeft: 4, marginTop: -1 }}
                    />
                  </Bubble> */}
                  <TipContext
                    tipText={
                      <>
                        {formatMessage({
                          id: 'dbi_compare_mobile_key_metric_tips',
                        })}
                        <br />
                        {formatMessage({
                          id: 'dbi_info_mobile_compare_datasource_range',
                        })}
                      </>
                    }
                  />
                </div>
                <MetricTable
                  showHeatMap={heatMap}
                  showCountries={showCountries}
                  MAXGAMENUM={MAXGAMENUM}
                  list={gameList}
                />
                <Actionbar
                  disabled={echartLoading}
                  // @ts-ignore
                  rangePickerProps={{
                    hiddenHeaderBtns: ['All of time'],
                    defaultValue: latestTimeTypeHasData,
                  }}
                  composedDateData={composedDateData}
                  onComposedPickerChange={handleComposeDateChange}
                  downloadNodeRenderer={() => (
                    <>
                      <ExportTable
                        entityType={entityType}
                        businessType="compare-mobile"
                        downloadModalSize="l"
                        isOnlyExportAllData={true}
                        isDisableDownload={loading}
                        excelName={mainSegmentText}
                        total={gameList?.length}
                        downloadLogConfigKey={compareMobileGames?.[`${entityType}_${mainSegment}`]}
                        tableParams={{
                          ...apiData,
                          granularity: getDateTypeOfBackend(echartDateType as DateTypeFrontend),
                          date_type: getDateTypeOfBackend(echartDateType as DateTypeFrontend),
                          // 时间默认为空时会报错，D1范围时间下载用默认往前推30天
                          start_date:
                            formatDateStrPlus(absoluteDateValue?.[0]) ||
                            moment().subtract(1, 'd').format('YYYY-MM-DD'),
                          end_date:
                            formatDateStrPlus(absoluteDateValue?.[1]) ||
                            moment().subtract(30, 'd').format('YYYY-MM-DD'),
                          gameCode: [],
                          game_code: [],
                          compare_is_launch_date:
                            composedDateData?.mode === ComposedDateMode.Relative,
                          compare_download_date: getDownloadDates(
                            gameList,
                            composedDateData?.mode === ComposedDateMode.Relative,
                            getOtherDateFormat(composedDateData?.dateType),
                            relativeDateValue,
                          ),
                          company: [],
                          platforms: ['unified'],
                          aggregate: 0,
                          genre: [],
                          sub_genre: [],
                          start_release_time: null,
                          end_release_time: null,
                          ratio_type: 0,
                          chart_type: 0,
                          order_source: 'sensortower',
                          order_metric: 'au',
                          order: 'desc',
                          page: 1,
                          page_size: 100,
                          default_data_sources: apiData?.data_sources,
                        }}
                      />
                    </>
                  )}
                />
                <Abnormal
                  style={{ height: 400 }}
                  isLoading={echartLoading}
                  isNoData={echartNoData}
                  component={
                    <>
                      <CumulativeTable
                        metric={mainSegment}
                        data={trends}
                        MAXGAMENUM={MAXGAMENUM}
                        dateType={echartDateType}
                      />
                      <Visualis
                        isVisualisLoading={loading}
                        isNodata={echartNoData}
                        isShowRangeDayMonth={composedDateData.mode === ComposedDateMode.Relative}
                        topChartsType={topChartsType}
                        imageType={entityType}
                        dateType={echartDateType}
                        titleNow=""
                        dataSources={apiData?.data_sources}
                        lineData={lineData}
                      />
                    </>
                  }
                />
              </div>
            </CardSlotV2>
          )}
        </>
      )}

      {/* 添加游戏弹窗 */}
      <AddEntities
        entityKey="gameId"
        entities={gamesEntities}
        visible={visible}
        entityRenderer={EntityRenderer}
        keywordsFetcher={fetchKeywords}
        entitiesFetcher={fetchGamesByKeyword}
        similarEntitiesFetcher={fetchSimilarGames}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onConfirm={handleCompareConfirm}
        onClose={handleCompareCancel}
      />
      {ClearVisible && (
        <Modal
          size={500}
          visible={ClearVisible}
          // caption={formatMessage({ id: 'dbi_compare_clear_all' })}
          onClose={() => {
            setClearVisible(false);
          }}
        >
          <Modal.Body>
            <div className="dbi-compare-modal-context">
              {formatMessage({ id: 'dbi_compare_clear_all_confirm_tips' })}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="primary"
              onClick={() => {
                setClearVisible(false);
                handleClearGame();
              }}
            >
              {formatMessage({ id: 'dbi_confirm' })}
            </Button>
            <Button
              type="weak"
              onClick={() => {
                setClearVisible(false);
              }}
            >
              {formatMessage({ id: 'dbi_cancel' })}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default ActiveRevDown;
